const PilotStatus = {
  active: 'A',
  injured: 'I',
  killed: 'K',
  captured: 'C',
  lost: 'L',
  onLeave: 'O',
  transferred: 'T',
  bailedOut: 'B',
  isBailingOut: 'IB',
};
export default PilotStatus;
